import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

const SOCIALS = [
  { label: 'Facebook', Icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61584821811707', style: { backgroundColor: '#1877F2' } },
  { label: 'Instagram', Icon: Instagram, href: 'https://www.instagram.com/electronicoholdings/?hl=en', style: { background: 'linear-gradient(45deg,#feda75,#fa7e1e,#d62976,#962fbf,#4f5bd5)' } },
];

const SITEMAP = [
  {
    title: 'Company',
    links: [
      { label: 'Home', to: '/' },
      { label: 'About Us', to: '/about' },
      { label: 'Industries', to: '/industries' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Divisions',
    links: [
      { label: 'Electronic Security', to: '/divisions/electronic-security' },
      { label: 'Contract Manufacturing', to: '/divisions/contract-manufacturing' },
      { label: 'Multi Media Marketing', to: '/divisions/multimedia-marketing' },
    ],
  },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/10 bg-[#07101f]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo-link">
              <img src="/brand/logo.png" alt="Electronico" className="h-12 w-12 object-contain" />
              <span className="font-display font-bold text-lg">Electronico</span>
            </Link>
            <p className="text-sm text-white/50 mt-4 max-w-sm leading-relaxed">
              A diversified technology conglomerate delivering electronic security, contract
              manufacturing and multimedia marketing across Africa and beyond.
            </p>
            <div className="mt-4 text-sm text-white/50 space-y-1">
              <a href="mailto:info@electronico.co.za" className="block hover:text-white transition-colors">info@electronico.co.za</a>
              <a href="tel:+27210201435" className="block hover:text-white transition-colors">+27 21 020 1435</a>
              <span className="block">Hermanus, Western Cape</span>
            </div>
            <div className="mt-5 flex gap-3" data-testid="footer-socials">
              {SOCIALS.map(({ label, Icon, href, style }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  style={style}
                  className="h-10 w-10 rounded-xl flex items-center justify-center text-white shadow-lg hover:-translate-y-0.5 hover:shadow-xl transition-all"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Sitemap columns */}
          {SITEMAP.map((col) => (
            <div key={col.title} data-testid={`footer-col-${col.title.toLowerCase()}`}>
              <h4 className="font-mono-accent text-xs text-[#0ef3fe] uppercase tracking-widest mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-white/55 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">© {year} Electronico Holdings (Pty) Ltd. All rights reserved.</p>
            <div className="flex gap-5">
              <Link to="/terms" className="text-xs text-white/40 hover:text-white transition-colors">Terms of Use</Link>
              <Link to="/cookies" className="text-xs text-white/40 hover:text-white transition-colors">Cookie Policy</Link>
              <Link to="/terms" className="text-xs text-white/40 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-xs text-white/40 hover:text-white transition-colors">POPIA</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
